
<div>
    <c-list-card
        :height      = "80"
        :edit        = "false"
        border-width = "pa-2"
        @selected    = "onClick"
        @context     = "onContext"
    >
        <template v-slot:title>
            <div class="card-title title-line">
                {{ event.elevatorNo }} - {{ event.elevatorType.name }}
            </div>
            <v-spacer />
            <div class="text-right customer-name">
                {{ event.customer.name }}
            </div>
        </template>
        <template v-slot:body>
            <div class="card-subtitle v-flex">
                <div class="address-line">
                    {{ event.location.street }}, {{ event.location.zipCode }} {{ event.location.city }}
                </div>
                <v-spacer />
            </div>
            <div class="card-subtitle v-flex primary--text">
                {{ type }} seit {{ formatDate (event.received) }}
            </div>
        </template>
    </c-list-card>


    <v-menu
        v-model="showMenu"
        :position-x="x"
        :position-y="y"
        absolute
        offset-y
    >
        <v-list>
            <v-list-item @click = "onCreate">
                <v-list-item-title>Störung für Stillstand anlegen</v-list-item-title>
            </v-list-item>
            <v-list-item @click = "onClick(true)">
                <v-list-item-title>Gehe zur Ereignishistorie der Anlage</v-list-item-title>
            </v-list-item>
        </v-list>
    </v-menu>
</div>
